// @flow

const mapFacebookResponse =
  (facebookUser: FacebookUser, loginInfo: FacebookLoginResponse): ApplicantCreateAttributes => ({
    firstName: facebookUser.first_name,
    lastName: facebookUser.last_name,
    email: facebookUser.email,
    type: 'facebook',
    extraInfo: loginInfo.authResponse,
  });

export default mapFacebookResponse;
